import { render } from "./RegImgUpload.vue?vue&type=template&id=6732bd8c"
import script from "./RegImgUpload.vue?vue&type=script&lang=js"
export * from "./RegImgUpload.vue?vue&type=script&lang=js"

import "./RegImgUpload.vue?vue&type=style&index=0&id=6732bd8c&lang=scss"

import exportComponent from "C:\\geneuin\\developer\\hwian\\hwian_install_admin_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__